export default __webpack_public_path__ + "stumbler-screens.71303592.png";